import {
  sendGetRequest,
  sendPostRequest,
  sendPutRequest,
  sendDeleteRequest
} from '../requests';
import {QueryParamsProps} from '../../constants/types';

const baseUrl = '/call-sheets';

export const getAllCallSheets = (body, params: QueryParamsProps) =>
  sendPostRequest(baseUrl, body, params);

export const getCallSheetById = (id: number | string) =>
  sendGetRequest(`${baseUrl}/${id}`);

export const updateCallSheetById = (id: number | string, body) =>
  sendPutRequest(`${baseUrl}/${id}`, body);

export const deleteCallSheetById = (id: number) =>
  sendDeleteRequest(`${baseUrl}/${id}`);

export const getLatestSchedulingProcess = (id: number | string) =>
  sendGetRequest(`${baseUrl}/${id}/latest-scheduling-process`);
